import debounce from 'debounce';
import select from 'dom-select';

export const FindAProviderStoryBook = (el) => {
  const ui = {
    el,
    body: select('body', document),
    detailsElement: select('.find-a-provider__details', el),
    detailsSummary: select('.find-a-provider__details .summary span', el),
    submitButton: select('[type="submit"]', el),
    affiliateRadios: select.all('[name="affiliate"]', el),
    radioHHP: select('#radio-hhp', el),
    radioHPHMG: select('#radio-hphmg', el),
    radioAll: select('#radio-all-providers', el),
    labelAll: select('#all-tab', el),
    labelHPHMG: select('#hphmg-tab', el),
    labelHHP: select('#hhp-tab', el),
    specialty: select('#select-specialty', el),
    subSpecialty: select('#select-sub-specialty', el),
  };

  const pagewidthThreshold = 1024;

  const handleSubspecialty = () => {
    if (ui.specialty.value) {
      ui.subSpecialty.removeAttribute('disabled');
    } else {
      ui.subSpecialty.setAttribute('disabled', 'true');
    }
  }

  const handleFiltersToggle = () => {
    if (ui.detailsElement.open) {
      ui.detailsSummary.innerHTML = "Show filters";
    } else {
      ui.detailsSummary.innerHTML = "Show filters";
    }
  }

  const handleURLparams = () => {

  const urlParams = new URLSearchParams(window.location.search);
  const affiliate = urlParams.get('affiliate');

  switch (affiliate) {
    case 'HPHMG':
      if (!ui.radioHPHMG.checked) ui.radioHPHMG.checked = true;
      ui.labelHPHMG.classList.add('is-active');
      break;
    case 'HHP':
      if (!ui.radioHHP.checked) ui.radioHHP.checked = true;
      ui.labelHHP.classList.add('is-active');
      break;
    case 'all':
    default:
      if (!ui.radioAll.checked) ui.radioAll.checked = true;
      break;
    }

    // Simulate, for now, what the back-end will do for us later
    const formSubmitted = urlParams.get('form-submitted');
    if (formSubmitted) {
      ui.el.setAttribute('data-result-count', '9');
    }
  };

  const handleResize = () => {
    if (ui.body.offsetWidth >= pagewidthThreshold) {
      ui.detailsElement.setAttribute('open', 'true');
    } else {
      ui.detailsElement.removeAttribute('open');
    }
  };

  const addEvents = () => {
    handleResize();
    handleURLparams();
    handleFiltersToggle();

    window.onresize = debounce(() => {
      handleResize();
    }, 50);

    ui.specialty.addEventListener('change', () => {
      handleSubspecialty();
    });

    ui.detailsElement.addEventListener('toggle', (event) => {
      handleFiltersToggle(event);
    });
  }

  const init = () => {
    addEvents();
  };

  init();
};

export default FindAProviderStoryBook;
